export default function MessageAlert({ text }: { text: any }) {
  return (
    <div className="rounded-md bg-yellow-50 px-2 py-4 shadow-sm">
      <p className="text-sm text-yellow-700">{text}</p>
    </div>
  );
}
